/**
 * Formats as (XXX) XXX-XXXX
 * @param value - The phone number string being typed
 * @returns Formatted phone number string
 */
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '').slice(-10);

  if (digits.length !== 10) {
    return value;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}
